module.exports = __webpack_public_path__ + "static/media/feedback_3.5c79fc2a.png";